<div class="model-wrapper">
  <nz-card>
    <div class="header-card">
      <nz-card>
        <div class="header-wrapper">
          <div class="left-section">
            <h3 nz-typography class="nfl-form-label">{{ modelData?.name }}</h3>
            <p nz-typography>{{ modelData?.lastModifiedAt | dateTime }}</p>
            <div class="sub-attributes" *ngIf="modelData?.status === 'SUCCESS'">
              <p nz-typography class="label">Seed Audience:</p>
              <span>{{ modelData?.queryName }}</span>
            </div>
            <div class="sub-attributes" *ngIf="modelData?.status === 'SUCCESS'">
              <p nz-typography class="label">Query ID:</p>
              <span>{{ modelData?.queryId }}</span>
            </div>
            <div class="sub-attributes" *ngIf="modelData?.status === 'SUCCESS'">
              <p nz-typography class="label">Run By:</p>
              <span>{{ modelData?.lastModifiedBy || modelData?.createdBy }}</span>
            </div>
            <div class="sub-attributes" *ngIf="modelData?.status === 'SUCCESS' && modelData?.lookalikeNumber">
              <p nz-typography class="label">Lookalike size:</p>
              <span>{{ modelData?.lookalikeNumber | number }}</span>
            </div>
          </div>
          <div class="right-section">
            <div class="success" *ngIf="modelData?.status === 'SUCCESS'">
              <span nz-icon nzType="check-circle" nzTheme="outline"></span>
              <p nz-typography>Success</p>
            </div>
            <div class="error" *ngIf="modelData?.status === 'FAIL'">
              <span nz-icon nzType="close-circle" nzTheme="outline"></span>
              <p nz-typography>Failed</p>
            </div>
          </div>
        </div>
      </nz-card>
    </div>
    <div class="body-card">
      <nz-card *ngIf="modelData?.status === 'FAIL'">
        <div class="error">
          <h3 nz-typography class="nfl-form-label">Model failed to run due to an internal error</h3>
          <p nz-typography>Please contact the admin for the support</p>
        </div>
      </nz-card>
      <div class="form-wrapper" *ngIf="modelData?.status === 'SUCCESS'">
        <div>
          <ng-container
            *ngIf="modelData?.modelType === 'LOOKALIKE'; then whiteSpaceDistributionTemplate"
          ></ng-container>
          <nz-card [class.first-image]="modelData?.modelType === 'LOOKALIKE'" class="mb0">
            <ng-container *ngIf="modelData?.modelType === 'BASE'; then whiteSpaceDistributionTemplate"></ng-container>
            <img [src]="getImageUrl(WHITESPACE_DISTRIBUTION_IMAGE)" [alt]="modelData?.name" class="w100" />
          </nz-card>
          <ng-template #whiteSpaceDistributionTemplate>
            <h3 nz-typography class="nfl-form-label">{{ getImageHeader(WHITESPACE_DISTRIBUTION_IMAGE) }}</h3>
          </ng-template>
        </div>
        <nz-card *ngIf="modelData?.modelType === 'BASE'">
          <div class="card-body">
            <h3 nz-typography class="nfl-form-label">Create Lookalike</h3>
            <form nz-form [nzLayout]="'vertical'" [formGroup]="lookalikeForm!" class="form-grid">
              <div nz-row [nzGutter]="[16, 24]">
                <div nz-col class="gutter-row" [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true"
                      >Lookalike Audience Name</nz-form-label
                    >
                    <nz-form-control [nzErrorTip]="nameErrorTemplate">
                      <input
                        nz-input
                        formControlName="name"
                        id="name"
                        name="name"
                        placeholder="Enter Lookalike Audience Name"
                      />
                    </nz-form-control>
                  </nz-form-item>
                  <ng-template #nameErrorTemplate let-control>
                    <div *ngIf="control?.errors?.['required']">Lookalike audience name is required</div>
                    <div *ngIf="control?.errors?.['maxlength']">
                      Lookalike audience name cannot exceed
                      {{ control?.errors?.['maxlength'].requiredLength }} characters.
                    </div>
                    <div *ngIf="control?.errors?.['pattern']">
                      Lookalike audience name should not contain any special characters and should have at least one
                      alphabet.
                    </div>
                  </ng-template>

                  <nz-form-item>
                    <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true">
                      Number of lookalikes (Max {{ MAX_LOOKALIKE_NUMBER | number }})
                    </nz-form-label>
                    <nz-form-control [nzErrorTip]="lookalikeNumberErrorTemplate">
                      <input
                        nz-input
                        type="number"
                        formControlName="lookalikeNumber"
                        id="lookalikeNumber"
                        placeholder="Enter Number of Lookalikes"
                        class="w100"
                      />
                    </nz-form-control>
                  </nz-form-item>
                  <ng-template #lookalikeNumberErrorTemplate let-control>
                    <div *ngIf="control?.errors?.['required']">Number of lookalikes is required</div>
                    <div *ngIf="control?.errors?.['min']">Number of lookalikes must be at least 1</div>
                    <div *ngIf="control?.errors?.['max']">
                      Number of lookalikes cannot exceed {{ MAX_LOOKALIKE_NUMBER }}
                    </div>
                    <div *ngIf="control?.errors?.['pattern']">Only numbers are allowed</div>
                  </ng-template>
                </div>
              </div>
              <div class="button-container">
                <button
                  nz-button
                  nzType="primary"
                  [nzLoading]="isLoading"
                  [disabled]="lookalikeForm.invalid"
                  (click)="createLookalike()"
                >
                  <span>Create Lookalike</span>
                </button>
              </div>
            </form>
          </div>
        </nz-card>
      </div>
      <div>
        <div *ngIf="modelData?.status === 'SUCCESS' && modelData?.modelType === 'LOOKALIKE'">
          <h3 nz-typography class="nfl-form-label">Lookalike Distribution</h3>
          <ng-container *ngFor="let image of imagesForLookalike">
            <nz-card class="lookalike-card">
              <h5 nz-typography class="nfl-form-label">{{ getImageHeader(image) }}</h5>
              <img [src]="getImageUrl(image)" [alt]="modelData?.name" class="w100" />
            </nz-card>
          </ng-container>
        </div>
      </div>

      <div class="footer-button">
        <button nz-button nzType="default" (click)="goToHistory()">
          <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
          <span>Back</span>
        </button>
        <div *ngIf="modelData?.status === 'SUCCESS'">
          <span><i class="legend-icon h_similar"></i>Highly Similar</span>
          <span><i class="legend-icon m_similar"></i>Moderately Similar</span>
          <span><i class="legend-icon s_similar"></i>Slightly Similar</span>
        </div>
      </div>
    </div>
  </nz-card>
</div>
<div class="spinner-overlay" *ngIf="isLoading">
  <nz-spin nzSpinning="true" nzSize="large">
    <div class="spinner-content">Loading Model Data...</div>
  </nz-spin>
</div>
